/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 *
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

// Base URL for Netlify function calls (/.netlify/functions/...).
//
// On the web, the app is served from the same origin as the functions, so a
// relative URL normally works fine. But inside the Capacitor native app, the
// WebView's origin is https://localhost, not the real deployed domain, so a
// relative fetch resolves to a URL that doesn't exist on the device and
// silently falls back to the app's own index.html (via Capacitor's SPA
// routing), which then fails to parse as JSON.
//
// REACT_APP_BASE_URL should be set to the deployed portal's real origin
// (https://portal.merch-sherpa.com) so these calls work both on the web and
// inside the native app.
export const API_BASE_URL = process.env.REACT_APP_BASE_URL || window.location.origin;
